// Mock data for frontend-only implementation
// This will be replaced with real backend integration later

export const mockBookings = [
  {
    id: '1',
    clientName: 'John Doe',
    email: 'john@example.com',
    phone: '9876543210',
    service: 'Individual Therapy Session',
    date: '2025-08-25',
    time: '10:00 AM',
    amount: 1000,
    status: 'confirmed',
    createdAt: '2025-08-20'
  },
  {
    id: '2',
    clientName: 'Sarah Smith',
    email: 'sarah@example.com',
    phone: '9876543211',
    service: 'Discovery Call',
    date: '2025-08-26',
    time: '2:00 PM',
    amount: 250,
    status: 'pending',
    createdAt: '2025-08-21'
  }
];

export const services = [
  {
    id: '1',
    title: 'Discovery Call',
    duration: '20 Minutes',
    price: 250,
    description: 'A short introductory call to understand your concerns and see how we can work together.',
    features: ['Initial consultation', 'Understanding your needs', 'Therapy approach discussion']
  },
  {
    id: '2',
    title: 'Individual Therapy Session',
    duration: '60 Minutes',
    price: 1000,
    description: 'A deep, focused session tailored to your healing, growth, and personal well-being.',
    features: ['One-on-one session', 'Personalized therapy', 'CBT techniques', 'Confidential space']
  },
  {
    id: '3',
    title: '3-Session Momentum Package',
    duration: '3 × 60 Minutes',
    price: 2800,
    originalPrice: 3000,
    savings: 200,
    description: 'Focused support for meaningful, structured progress.',
    features: ['Three 60-min sessions', 'Structured progress tracking', 'Save Rs. 200', 'Flexible scheduling']
  },
  {
    id: '4',
    title: '5-Session Deep Transformation Package',
    duration: '5 × 60 Minutes',
    price: 4500,
    originalPrice: 5000,
    savings: 500,
    description: 'Deep and consistent clinical support for lasting behavioral change.',
    features: ['Five 60-min sessions', 'Comprehensive support', 'Save Rs. 500', 'Long-term change focus']
  }
];

export const freeResources = [
  {
    id: 'free-1',
    title: 'The Cognitive Reframing Daily Log',
    type: 'PDF Worksheet',
    description: 'A simple, highly functional 3-column CBT tool designed to track automatic negative thoughts, identify cognitive distortions (like catastrophizing), and construct rational, balanced thoughts.',
    icon: 'FileText',
    downloadUrl: '#'
  },
  {
    id: 'free-2',
    title: 'Grounding Through the Storm: An Anxiety S.O.S Guide',
    type: 'Psychoeducation Guide',
    description: 'A concise, text-based breakdown explaining how the sympathetic nervous system handles acute threat projection, paired with a physical 5-4-3-2-1 sensory grounding exercise.',
    icon: 'Heart',
    downloadUrl: '#'
  }
];

export const paidResources = [
  {
    id: 'paid-1',
    title: 'The Ultimate OCD Exposure & Response Prevention (ERP) Planner',
    price: 299,
    type: 'Digital Workbook',
    description: 'A structured digital workbook helping clients build an anxiety hierarchy, track trigger exposure levels, record response prevention success, and logically map progress over a 30-day period.',
    icon: 'BookOpen',
    features: ['30-day structured plan', 'Anxiety hierarchy builder', 'Progress tracking', 'Response prevention logs']
  },
  {
    id: 'paid-2',
    title: 'The Mind Tunnel Boundary Matrix: Managing Burnout & Life Transitions',
    price: 199,
    type: 'Self-Guided Workbook',
    description: 'An intensive self-guided psychoeducational workbook centered around defining energetic boundaries, identifying personal "sinking points," and setting non-negotiable professional and personal limits to protect the nervous system.',
    icon: 'Shield',
    features: ['Boundary setting framework', 'Burnout assessment', 'Life transition toolkit', 'Energy management strategies']
  }
];

export const availableTimeSlots = [
  '9:00 AM', '10:00 AM', '11:00 AM', '12:00 PM',
  '2:00 PM', '3:00 PM', '4:00 PM', '5:00 PM', '6:00 PM'
];

export const testimonials = [
  {
    id: 1,
    name: 'Anonymous Client',
    text: 'Working with Ayesha has been transformative. Her approach helped me break free from years of anxiety and overthinking.',
    rating: 5
  },
  {
    id: 2,
    name: 'Anonymous Client',
    text: 'I finally found a therapist who truly listens without judgment. The CBT techniques have made a real difference in my daily life.',
    rating: 5
  }
];